const aPackage = require("../../package.json");
const v2 = process.env.REACT_APP_CI_BUILD || "";
export default aPackage.version + (v2 != "" ? "." + v2 : "");